import HomePage from './components/HomePage'

// Sync route definition
export default {
  component: HomePage,
}



// WEBPACK FOOTER //
// ./src/routes/Home/index.js